import React, { useState } from "react";
import { EmailActionButton } from "../../common/ActionIconButton";
import DocumentChasingSendPopup from "./DocumentChasingSendPopup";

/*** Per-document "Document Chasing" action button for the Requested section.
 * Enabled only for pending documents (Requested/Rejected); clicking opens a
 * compact Send Email popup scoped to just this one document. ***/
const DocumentChasingActionButton = ({ tableValues, clientID }) => {
  const [open, setOpen] = useState(false);
  const status = tableValues.document_status?.toLowerCase();
  const isChasable = status === "requested" || status === "rejected";

  return (
    <>
      <EmailActionButton
        onClick={() => setOpen(true)}
        disabled={!isChasable}
        disabledReason="Document chasing is only available for requested or rejected documents"
      />
      {open && (
        <DocumentChasingSendPopup
          open={open}
          onClose={() => setOpen(false)}
          clientID={clientID}
          documentRequestId={tableValues.document_request_id}
          documentName={tableValues.document_req_name}
        />
      )}
    </>
  );
};

export default DocumentChasingActionButton;
